import {http} from '@/helpers/http-helper';

class AssociatedProject {
    constructor(
        uuid,
        name,
        description,
        startDate,
        endDate,
        createdBy,
        createdAt,
        updatedBy,
        updatedAt,
        active
    )
    {
        this.uuid = uuid;
        this.name = name;
        this.description = description;
        this.startDate = startDate;
        this.endDate = endDate;
        this.createdBy = createdBy;
        this.createdAt = createdAt;
        this.updatedBy = updatedBy;
        this.updatedAt = updatedAt;
        this.active = active;
    }
}

export const getAssociatedProjects = () => {
    return new Promise( (resolve, reject) => {
        const url = 'associated-projects';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let associatedProjects = [];

                    response.data.forEach((associatedProject) => {
                        associatedProjects.push(
                            new AssociatedProject(
                                associatedProject.uuid,
                                associatedProject.name,
                                associatedProject.description,
                                associatedProject.startDate == null ? null : new Date(associatedProject.startDate),
                                associatedProject.endDate == null ? null : new Date(associatedProject.endDate),
                                associatedProject.createdBy,
                                new Date(associatedProject.createdAt),
                                associatedProject.updatedBy,
                                new Date(associatedProject.updatedAt),
                                associatedProject.active)
                        );
                    });

                    resolve(associatedProjects);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createAssociatedProject = (newAssociatedProject) => {
    return new Promise( (resolve, reject) => {
        const url = 'associated-projects';
        http.post(url, newAssociatedProject)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateAssociatedProject = (associatedProject) => {
    return new Promise( (resolve, reject) => {
        const url = 'associated-projects/' + associatedProject.uuid;
        http.post(url, associatedProject)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getAssociatedProject = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'associated-projects/' + uuid;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let associatedProject = response.data;

                    associatedProject = new AssociatedProject(
                        associatedProject.uuid,
                        associatedProject.name,
                        associatedProject.description,
                        new Date(associatedProject.startDate),
                        new Date(associatedProject.endDate),
                        associatedProject.createdBy,
                        new Date(associatedProject.createdAt),
                        associatedProject.updatedBy,
                        new Date(associatedProject.updatedAt),
                        associatedProject.active);

                    resolve(associatedProject);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteAssociatedProject = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'associated-projects/' + uuid;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMemberAssociatedProjects = (memberId) => {
    return new Promise((resolve, reject) => {
        const url = '/members/' + memberId + '/associated-projects/';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const applyAssociatedProjectToMember = (memberId, associatedProjectId, applicationDate) => {
    return new Promise((resolve, reject) => {
        const url = '/members/' + memberId + '/associated-projects/' + associatedProjectId;
        http.post(url, {applicationDate: applicationDate})
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const stopApplyingAssociatedProjectToMember = (memberId, associatedProjectId) => {
    return new Promise((resolve, reject) => {
        const url = '/members/' + memberId + '/associated-projects/' + associatedProjectId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};